module.exports = __webpack_public_path__ + "img/hire3x-newicon.34b0b551.svg";